export enum AdPlacements {
    INTERSTITIAL = "interstitial",
    REWARDED = "rewarded",
    BANNER = "banner",
}
